import { SowingDateResObj } from '@/models/cropGuide'

import { get } from '../axios'

const getSowingDates = () => get<SowingDateResObj[]>(`/khetibook/v1/sowing`)

export default getSowingDates
